
export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(() => console.log('SW registered:')) // , reg))
      .catch((err) => console.error('SW registration failed:', err));
    });
  } else {
    console.log("Your navigator has no ServiceWorker");
  }
}